



















































import { Component, Prop, Vue } from "vue-property-decorator";
import ApprovalItem from "@/components/editor/base/ApprovalItem.vue";
import Entry from "@/interfaces/uniabc/Entry";
import { readEntryByLabel } from "@/store/uniabc/getters";
import { dispatchSelfApprovalNow } from "@/store/uniabc/actions";
import DateUtils from "@/utils/DateUtils";

@Component({
  components: { ApprovalItem }
})
export default class ItemInfoBar extends Vue {
  @Prop(String) readonly label!: string;
  private entry!: Entry;

  public async created() {
    this.entry = readEntryByLabel(this.$store)(this.label || "");
  }

  private async approve() {
    await dispatchSelfApprovalNow(this.$store, this.label);
  }

  private toShortDateStr(date: Date) {
    return DateUtils.getShortDateTimeString(new Date(date));
  }
}
